export default __webpack_public_path__ + "media/images/slider/slider-1-0397f85b4801ea89cd35db416814551d.png";